<template>
    <div class="tw-text-center tw-flex tw-flex-col tw-flex-1 tw-items-center tw-justify-center tw-overflow-scroll">
        <div class="tw-flex tw-items-center tw-text-xl tw-text-red-500 tw-font-bold tw-border-b tw-border-blue-0 tw-px-4 tw-pb-6 tw-mb-6">
            <i class="fa fa-clock tw-pr-2 tw-pt-1"></i>
            <h2 style="margin-bottom: 0;">{{ translations['quiz.out_of_time'] }}</h2>
        </div>
        <h3 class="tw-text-gray-500 tw-pb-6 tw-leading-loose tw-px-8">
            {{ translations['quiz.timer_ran_out_1'] }} <b>{{ getAmountOfAnsweredQuestions }}</b> {{ translations['quiz.out_of'] }} <b>{{ getAmountOfQuestions }}</b> {{ translations['quiz.timer_ran_out_2'] }} <b>{{ getAmountOfCorrectAnswers }}</b> {{ translations['quiz.timer_ran_out_3'] }}
        </h3>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Global from '../../../mixins/Global.js';

    export default {
        mixins: [Global],
        name: 'QuizTimeRanOut',

        computed: {
            ...mapGetters('quiz', ['getAmountOfQuestions', 'getAmountOfAnsweredQuestions', 'getAmountOfCorrectAnswers']),
        }
    }
</script>